import { IconButton, Modal } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { ImagePlaceholder } from "./ImagePlaceholder";

export function ProductModal({ isOpen, onClose, title, imgUrl, description, price }) {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <div className="flex absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-screen-xl outline-none p-4 max-h-full">
                <div className="flex flex-col md:flex-row items-start gap-6 bg-white p-8 pt-12 md:pt-8 rounded-lg shadow-md text-left max-h-full overflow-auto w-full">
                    <div className="w-full md:w-1/3">
                        {imgUrl ? (
                            <img src={imgUrl} className="w-full object-contain max-w-full rounded-md" />
                        ) : (
                            <ImagePlaceholder className="h-auto" />
                        )}
                    </div>
                    <div className="w-full md:w-2/3">
                        <div className="space-y-2">
                            <div className="flex justify-between items-center">
                                <div className="text-3xl font-bold">
                                    {title}
                                </div>
                                <div className="absolute right-6 top-6 z-10 md:relative md:inset-0">
                                    <IconButton
                                        aria-label="close"
                                        onClick={onClose}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div className="text-2xl font-semibold text-gray-600">
                                {price}
                            </div>
                            <div className="leading-normal">{description}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
